import script from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"

import "./CheckBox.vue?vue&type=style&index=0&id=5782f212&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5782f212"]])

export default __exports__